import useCustomFieldsHook from "@/hooks/use-custom-fields.hook.tsx";
import { useTitle } from "@/hooks/use-title.hook.ts";
import { CustomFieldList } from "@/pages/settings/custom-fields/components/CustomFieldList.tsx";
import { useTabsByEntityType } from "@/queries/use-custom-fields.query.ts";
import { ApiEmployeeTab, ApiCFEntityTypes } from "@/types/custom-field.types.ts";
import { Page, Stack, TabButton, TabList, Title } from "@skailer-com/uikit";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

export function EmployeeCustomFieldsIndex() {
  const { t } = useTranslation();
  const { getTabTitle } = useCustomFieldsHook();
  useTitle(t("custom_fields:settings_title"), t("common:settings"));
  const { tab_id } = useParams();

  const navigate = useNavigate();

  const { data: employeeTabs } = useTabsByEntityType(ApiCFEntityTypes.employee);

  const systemEmployeeTabs: ApiEmployeeTab[] =
    employeeTabs?.map((tab) => ({
      id: tab.id,
      title: getTabTitle(tab) || "",
      type: tab.type,
    })) ?? [];

  const handleTabChanged = (tab: ApiEmployeeTab) => {
    if (tab.id === 0) {
      navigate(`/settings/custom-fields`);
    } else {
      navigate(`/settings/custom-fields/tab/${tab.id}`);
    }
  };

  const activeTabId = tab_id ? Number(tab_id) : 0;

  useEffect(() => {
    if (!tab_id && systemEmployeeTabs.length > 0) {
      navigate(`/settings/custom-fields/tab/${systemEmployeeTabs[0].id}`, { replace: true });
    }
  }, [tab_id, systemEmployeeTabs, navigate]);

  return (
    <Page>
      <Page.Header title={t("custom_fields:settings_title")} showBack={true}></Page.Header>
      <Page.Content>
        <Stack className="px-16">
          <Title
            header={t("custom_fields:fields")}
            caption={t("custom_fields:fields_how_works")}
            paddingTop
            paddingBottom
            size="lg"
          />
          <TabList>
            {systemEmployeeTabs.map((tab) => (
              <TabButton
                key={tab.id}
                title={tab.title}
                isActive={activeTabId === tab.id}
                onClick={() => handleTabChanged(tab)}
              />
            ))}
          </TabList>
          <CustomFieldList key={activeTabId} tabId={activeTabId} />
        </Stack>
      </Page.Content>
    </Page>
  );
}
